import React from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";
import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { BetBuilderPicksOfferTips } from "../BetBuilderPicksOfferTips";
import { QuickPlayPopupsTeams } from "@features/quick-play/desktop/common/QuickPlayPopupsTeams";
import QuickPlayEventResultAndTime from "@features/quick-play/shared/QuickPlayEventResultAndTime";

export default observer(function BetBuilderPickPopupBody(props: {
	BBPick: BetBuilderPick;
}) {
	const rootStore = useRootAppStore();
	const event =
		rootStore.quickPlayStore.betBoosterStore.eventsResultHubStore.getEvent(
			props.BBPick.eventId
		);

	return (
		<div className="card card--qp card--qp--scroll card--bbp u-padd--reset">
			<div className="card__body card--qp__body card--bbp__body">
				<QuickPlayEventResultAndTime
					event={event}
					startTime={props.BBPick.startTime}
				/>
				<div className="card--qp__event card--bbp__event">
					<QuickPlayPopupsTeams
						sportData={props.BBPick.multiOffers[0].sportData}
						eventId={props.BBPick.eventId}
						sportId={props.BBPick.sportId}
						isBetBuilder
					/>
				</div>
				<div className="card--qp__offer card--bbp__offer">
					<BetBuilderPicksOfferTips
						multiOffers={props.BBPick.multiOffers}
						isWrapped={true}
					/>
				</div>
			</div>
		</div>
	);
});
